<template>
    <div class="favorite-empty-msg" v-if="emptyMsgArr != null">
        <h3>{{ emptyMsgArr.title }}</h3>
        <strong>{{ emptyMsgArr.title_info }}</strong>
        <ul>
            <ul>
                <li v-for="(item, index) in emptyMsgArr.step_list">
                    <span class="num">{{ index + 1}}</span>
                    <p v-if="index != 1" v-html="item.step"></p>
                    <p v-else>
                        <span>{{ getCorrectStr(item.step, 1) }}</span>
                        <svgIcon name="favorite-active" class="icon-favorite-active"/>
                        <span> {{ getCorrectStr(item.step, 2) }}</span>
                    </p>
                </li>
            </ul>
        </ul>
       <!-- {{emptyMsgArr}} -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'favorite-empty-msg',
        props: ['emptyMsgArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                cardID: this.$route.name,
            }
        },
        computed: mapGetters({
            favoritePage: 'loadFavoritePage',
        }),
        methods: {
            getCorrectStr(str, index) {
                var clearStr;
                if (index == 1) {
                    clearStr = str.split("<span>")[0];
                    return clearStr;
                } else {
                    clearStr = str.split("<span>")[1].replace('</span>', '');
                    return clearStr;   
                }
            },
        },
        created () {
            
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite-page/favorite-empty-msg.scss';
    @import '@/styles/components/favorite-page/respond/favorite-empty-msg-respond.scss';
</style>